import { Contact, Company, Activity, Meeting, User } from '../types';
import { ContactForm } from '../types';
import { Lead } from '../types';

export const mockUsers: User[] = [
  { 
    id: '00000000-0000-0000-0000-000000000001', 
    name: 'Ana García', 
    email: 'ana@ceroideas.com', 
    role: 'superadmin',
    isActive: true,
    createdAt: new Date('2024-01-01'),
    lastLogin: new Date()
  },
  { 
    id: '00000000-0000-0000-0000-000000000002', 
    name: 'Carlos López', 
    email: 'carlos@ceroideas.com', 
    role: 'user',
    isActive: true,
    createdAt: new Date('2024-01-15'),
    lastLogin: new Date('2024-12-10'),
    createdBy: '00000000-0000-0000-0000-000000000001'
  },
  { 
    id: '00000000-0000-0000-0000-000000000003', 
    name: 'María Rodríguez', 
    email: 'maria@ceroideas.com', 
    role: 'user',
    isActive: true,
    createdAt: new Date('2024-02-01'),
    lastLogin: new Date('2024-11-20'),
    createdBy: '00000000-0000-0000-0000-000000000001'
  },
];

export const mockContacts: Contact[] = [
  {
    id: '00000000-0000-0000-0000-000000000011',
    fullName: 'Juan Pérez',
    email: 'juan.perez@empresa.com',
    phone: '+34 666 123 456',
    company: 'TechCorp SL',
    role: 'Director de IT',
    leadStatus: 'en_seguimiento',
    productInterest: 'Desarrollo Web',
    owner: 'Ana García',
    createdAt: new Date('2024-01-15'),
    lastActivity: new Date('2024-12-01'),
    notes: 'Contacto muy interesado en renovar su página web. Presupuesto estimado: 15K€',
    attachments: []
  },
  {
    id: '00000000-0000-0000-0000-000000000012',
    fullName: 'Laura Martín',
    email: 'laura@startup.es',
    phone: '+34 677 987 654',
    company: 'InnovateNow',
    role: 'CEO',
    leadStatus: 'nuevo',
    productInterest: 'Branding y Marketing',
    owner: 'Carlos López',
    createdAt: new Date('2024-12-10'),
    lastActivity: new Date('2024-12-10'),
    notes: 'Startup en fase inicial. Necesita branding completo y estrategia de marketing.',
    attachments: []
  },
  {
    id: '00000000-0000-0000-0000-000000000013',
    fullName: 'Roberto Silva',
    email: 'roberto@comercial.com',
    phone: '+34 655 444 333',
    company: 'Comercial del Norte',
    role: 'Gerente Comercial',
    leadStatus: 'cerrado',
    productInterest: 'Desarrollo CRM',
    owner: 'María Rodríguez',
    createdAt: new Date('2024-11-20'),
    lastActivity: new Date('2024-11-28'),
    notes: 'Proyecto cerrado exitosamente. Tienda online implementada con 200+ productos.',
    attachments: []
  }
];

export const mockCompanies: Company[] = [
  {
    id: '00000000-0000-0000-0000-000000000021',
    name: 'TechCorp SL',
    email: 'info@techcorp.com',
    phone: '+34 91 123 4567',
    website: 'https://techcorp.com',
    contacts: ['00000000-0000-0000-0000-000000000011'],
    meetings: ['00000000-0000-0000-0000-000000000031'],
    tickets: []
  },
  {
    id: '00000000-0000-0000-0000-000000000022',
    name: 'InnovateNow',
    email: 'hello@innovatenow.es',
    phone: '+34 93 987 6543',
    website: 'https://innovatenow.es',
    contacts: ['00000000-0000-0000-0000-000000000012'],
    meetings: [],
    tickets: []
  }
];

export const mockActivities: Activity[] = [
  {
    id: '00000000-0000-0000-0000-000000000041',
    type: 'reunion',
    datetime: new Date('2024-12-01T10:00:00'),
    description: 'Reunión inicial para discutir requerimientos del proyecto web',
    contactId: '00000000-0000-0000-0000-000000000011',
    owner: 'Ana García'
  },
  {
    id: '00000000-0000-0000-0000-000000000042',
    type: 'correo',
    datetime: new Date('2024-12-10T14:30:00'),
    description: 'Envío de propuesta inicial de branding',
    contactId: '00000000-0000-0000-0000-000000000012',
    owner: 'Carlos López'
  },
  {
    id: '00000000-0000-0000-0000-000000000043',
    type: 'llamada',
    datetime: new Date('2024-11-28T16:00:00'),
    description: 'Llamada de seguimiento post-entrega del e-commerce',
    contactId: '00000000-0000-0000-0000-000000000013',
    owner: 'María Rodríguez'
  }
];

export const mockMeetings: Meeting[] = [
  {
    id: '00000000-0000-0000-0000-000000000031',
    title: 'Reunión inicial TechCorp',
    datetime: new Date('2024-12-15T11:00:00'),
    duration: 60,
    participants: ['Juan Pérez', 'Ana García'],
    description: 'Primera reunión para analizar necesidades del cliente',
    status: 'programada',
    meetLink: 'https://meet.google.com/abc-defg-hij',
    contactId: '00000000-0000-0000-0000-000000000011',
    owner: 'Ana García',
    assignedUserId: '00000000-0000-0000-0000-000000000001',
    createdBy: '00000000-0000-0000-0000-000000000001'
  }
];

export const mockContactForms: ContactForm[] = [
  {
    id: '1',
    name: 'contact-general',
    title: 'Contacto General',
    description: 'Formulario principal para consultas generales',
    fields: [
      {
        id: '1',
        type: 'text',
        label: 'Nombre completo',
        placeholder: 'Tu nombre completo',
        required: true,
        order: 1
      },
      {
        id: '2',
        type: 'email',
        label: 'Email',
        placeholder: 'tu@email.com',
        required: true,
        order: 2
      },
      {
        id: '3',
        type: 'tel',
        label: 'Teléfono',
        placeholder: '+34 666 123 456',
        required: false,
        order: 3
      },
      {
        id: '4',
        type: 'text',
        label: 'Empresa',
        placeholder: 'Nombre de tu empresa',
        required: false,
        order: 4
      },
      {
        id: '5',
        type: 'select',
        label: 'Producto de interés',
        required: true,
        options: ['Desarrollo Web', 'Branding y Marketing', 'E-commerce', 'Consultoría Digital'],
        order: 5
      },
      {
        id: '6',
        type: 'textarea',
        label: 'Mensaje',
        placeholder: 'Cuéntanos sobre tu proyecto...',
        required: true,
        order: 6
      }
    ],
    settings: {
      defaultOwner: 'Ana García',
      leadStatus: 'nuevo',
      sendNotification: true,
      notificationEmail: 'contacto@ceroideas.es',
      sendAutoResponse: true,
      autoResponseSubject: 'Gracias por contactarnos - Cero Ideas',
      autoResponseMessage: 'Hola,\n\nGracias por contactar con Cero Ideas. Hemos recibido tu consulta y nos pondremos en contacto contigo en las próximas 24 horas.\n\nSaludos,\nEquipo Cero Ideas'
    },
    createdAt: new Date('2024-11-01'),
    updatedAt: new Date('2024-12-01'),
    submissions: 45,
    isActive: true
  },
  {
    id: '00000000-0000-0000-0000-000000000052',
    name: 'landing-ecommerce',
    title: 'Landing E-commerce',
    description: 'Formulario específico para servicios de e-commerce',
    fields: [
      {
        id: 'field-7',
        type: 'text',
        label: 'Nombre',
        required: true,
        order: 1
      },
      {
        id: 'field-8',
        type: 'email',
        label: 'Email',
        required: true,
        order: 2
      },
      {
        id: 'field-9',
        type: 'text',
        label: 'Empresa',
        required: true,
        order: 3
      },
      {
        id: 'field-10',
        type: 'select',
        label: 'Tipo de e-commerce',
        required: true,
        options: ['Tienda nueva', 'Migración', 'Mejoras existente'],
        order: 4
      },
      {
        id: 'field-11',
        type: 'textarea',
        label: 'Detalles del proyecto',
        required: true,
        order: 5
      }
    ],
    settings: {
      defaultOwner: 'Carlos López',
      productInterest: 'E-commerce',
      leadStatus: 'nuevo',
      sendNotification: true,
      notificationEmail: 'ecommerce@ceroideas.es',
      sendAutoResponse: true,
      autoResponseSubject: 'Tu consulta de E-commerce - Cero Ideas',
      autoResponseMessage: 'Gracias por tu interés en nuestros servicios de e-commerce. Te contactaremos pronto para discutir tu proyecto.'
    },
    createdAt: new Date('2024-11-15'),
    updatedAt: new Date('2024-11-20'),
    submissions: 23,
    isActive: true
  }
];

export const mockLeads: Lead[] = [
  {
    id: '00000000-0000-0000-0000-000000000101',
    fullName: 'Pedro Martínez',
    email: 'pedro@startup.es',
    phone: '+34 688 555 444',
    company: 'StartupTech',
    role: 'CTO',
    source: 'form_web',
    status: 'nuevo',
    productInterest: 'Desarrollo IA',
    owner: 'Ana García',
    notes: 'Interesado en implementar IA en su plataforma. Startup en fase de crecimiento.',
    formData: {
      message: 'Necesitamos implementar IA en nuestra plataforma',
      budget: 'Entre 20K-50K',
      timeline: '3-6 meses'
    },
    score: 85,
    createdAt: new Date('2024-12-15'),
    updatedAt: new Date('2024-12-15'),
    nextFollowUp: new Date('2024-12-18')
  },
  {
    id: '00000000-0000-0000-0000-000000000102',
    fullName: 'Carmen Ruiz',
    email: 'carmen@boutique.com',
    phone: '+34 677 333 222',
    company: 'Boutique Carmen',
    role: 'Propietaria',
    source: 'phone_call',
    status: 'contactado',
    productInterest: 'E-commerce',
    owner: 'Carlos López',
    notes: 'Llamó interesada en crear tienda online. Tiene boutique física y quiere expandir.',
    formData: {},
    score: 70,
    createdAt: new Date('2024-12-12'),
    updatedAt: new Date('2024-12-14'),
    lastContactDate: new Date('2024-12-14'),
    nextFollowUp: new Date('2024-12-20')
  },
  {
    id: '00000000-0000-0000-0000-000000000103',
    fullName: 'Miguel Torres',
    email: 'miguel@consultora.es',
    phone: '+34 666 111 999',
    company: 'Torres Consulting',
    role: 'Director',
    source: 'referral',
    status: 'calificado',
    productInterest: 'Desarrollo CRM',
    owner: 'María Rodríguez',
    notes: 'Referido por cliente actual. Necesita CRM personalizado para su consultora.',
    formData: {},
    score: 90,
    createdAt: new Date('2024-12-08'),
    updatedAt: new Date('2024-12-10'),
    lastContactDate: new Date('2024-12-10'),
    nextFollowUp: new Date('2024-12-16')
  }
];